import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";
import {IntroJsTjeneste} from "felles/tjenester/IntroJs";
import {IAugmentedJQuery, IController} from "angular";

export class KommentarerKontroller implements IController{

    static regNavn = "KommentarerKontroller";

    static forInjisering() {
        return [
            regNavn.ng.$element,
            IntroJsTjeneste.regNavn,
            regNavn.gettext.gettextCatalog,
            KommentarerKontroller
        ]
    }

    constructor(private $element: IAugmentedJQuery, private introJs: IntroJsTjeneste, private gettextCatalog: gettextCatalog) {
    }

    $onInit(): void {
        this.initIntroJs();
    }

    //private metoder

    private initIntroJs() {
        this.introJs.visIntroForsinket(
          this.introJs.nyIntroduksjon('kommentarer')
            .leggTilSteg(
              1,
              {
                  title: this.gettextCatalog.getString('Kommentarer'),
                  intro: this.gettextCatalog.getString('Liste over dine og andres kommentarer på saker, oppgaver og beslutninger. Her kan du svare på kommentarer, og trykke deg inn til dit hvor hver kommentartråd hører til.'),
              }
            )
            .leggTilSteg(
              2,
              {
                  title: this.gettextCatalog.getString('Dine og andres kommentarer'),
                  intro: this.gettextCatalog.getString('Her velger du om du vil se dine egne eller andre gruppemedlemmers kommentartråder.'),
                  element: '[data-tips-id="kommentar-velger"]'
              }
            )
            .leggTilSteg(
              3,
              {
                  title: this.gettextCatalog.getString('Kommentartråd'),
                  intro: this.gettextCatalog.getString('Trykk på en kommentartråd for å åpne den her, se eventuelle svar, skrive egne svar, eller gå dit hvor kommentartråden hører til.'),
                  element: '[data-tips-id="kommentar-traad"]',
                  position: 'right'
              },
              () => this.$element.find('[data-tips-id="kommentar-traad"]').length > 0
            ),
          1000
        );
    }
}
